import { ensureIncreasingXValues } from "./utility/ensureIncreasingXValues.js";
/**
 * Gets the Subfile flags.
 * @param  flag - First byte of the subheader.
 * @returns The parameters.
 */
export class SubFlagParameters {
    changed;
    noPeakTable;
    modifiedArithmetic;
    constructor(flag) {
        this.changed = (flag & 1) !== 0;
        this.noPeakTable = (flag & 8) !== 0;
        this.modifiedArithmetic = (flag & 128) !== 0;
    }
}
/**
 * Parses the subheader (header of the subfile)
 * @param buffer - SPC buffer.
 * @returns subheader object
 */
export class SubHeader {
    //all formats have the same subheader
    parameters;
    exponentY;
    indexNumber;
    startingZ;
    endingZ;
    noiseValue;
    numberPoints;
    numberCoAddedScans;
    wAxisValue;
    reserved;
    constructor(buffer) {
        this.parameters = new SubFlagParameters(buffer.readUint8());
        this.exponentY = buffer.readInt8();
        this.indexNumber = buffer.readUint16();
        this.startingZ = buffer.readFloat32();
        this.endingZ = buffer.readFloat32();
        this.noiseValue = buffer.readFloat32();
        this.numberPoints = buffer.readUint32();
        this.numberCoAddedScans = buffer.readUint32();
        this.wAxisValue = buffer.readFloat32();
        this.reserved = buffer.readChars(4).replaceAll('\u0000', '').trim();
    }
}
/**
 * Set the X and Y axis (object with labels, values etc.)
 * @param x - X values array.
 * @param y - Y values array.
 * @param fileHeader - main file header.
 * @returns object with x and y as axis.
 */
export function setXYAxis(x, y, fileHeader) {
    const xAxis = /(?<label>.*?) ?[([](?<units>.*)[)\]]/.exec(fileHeader.xUnitsType);
    const yAxis = /(?<label>.*?) ?[([](?<units>.*)[)\]]/.exec(fileHeader.yUnitsType);
    const [oX, oY] = ensureIncreasingXValues(x, y);
    const variables = {
        x: {
            symbol: 'x',
            label: xAxis?.groups?.label || fileHeader.xUnitsType,
            units: xAxis?.groups?.units || '',
            data: oX,
            isDependent: false,
        },
        y: {
            symbol: 'y',
            label: yAxis?.groups?.label || fileHeader.yUnitsType,
            units: yAxis?.groups?.units || '',
            data: oY,
            isDependent: true,
        },
    };
    return variables;
}
//# sourceMappingURL=shared.js.map